import React, { Component } from 'react';
import { Big3DatePicker, NoResult, ComPhoto } from "../../../js/ComponentManager";
import { Big3Common } from '../../../js/IncludeManager'
import { format } from "date-fns";

/* 개발담당:양유빈
 * 화면기능: 내거래처 > 거래내역
 * 세부설명: 
*/

export class DealHistory extends Component {
    static displayName = DealHistory.name;

    constructor(props) {
        super(props);
        this.fromDate = format(Big3Common.Util.DateAdd(new Date(), -30), "yyyy-MM-dd");
        this.toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");     
        this.state = {
            FromDate: this.fromDate,
            ToDate: this.toDate,
            SelectMonth: 1,
            DealHistory:[]
        };
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleMonth_Click = this.handleMonth_Click.bind(this);
        this.handleSearch_Click=this.handleSearch_Click.bind(this);
        
    }
    //초기화
    componentDidMount() {
        this.CallDealHistoryListData();
    }
    async CallDealHistoryListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/GetDealHistoryList',
                {
                    FromDate: this.state.FromDate,
                    ToDate: this.state.ToDate,
                    SearchText: this.state.SearchText,
                    Uid:this.props.ContentState.Uid
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DealHistory = JSON.parse(Data.dataTable); 
                this.setState({ DealHistory:DealHistory});
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtListData", e);
        }
        finally{
            Big3Common.Util.LoadingOff();
        }
    }
    //월 버튼 클릭
    handleMonth_Click(event, Month) {
        let fromDate = format(Big3Common.Util.DateAdd(new Date(this.state.ToDate), -(Month * 30)), "yyyy-MM-dd");
        this.setState({ SelectMonth: Month, FromDate: fromDate });
        event.preventDefault();
    }
    //달력일자 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
        return false;
    }
    //검색버튼 클릭
    handleSearch_Click(event){
        this.CallDealHistoryListData();
        event.preventDefault();
    }
   
    Searchrender() {
        return(
             <div className="search_box_v2">
                <div className="select_month_box">
                    <div className={this.state.SelectMonth === 1 ? "month select" : "month"} onClick={(e) => { this.handleMonth_Click(e, 1) }}>1개월</div>
                    <div className={this.state.SelectMonth === 3 ? "month select" : "month"} onClick={(e) => { this.handleMonth_Click(e, 3) }}>3개월</div>
                    <div className={this.state.SelectMonth === 6 ? "month select" : "month"} onClick={(e) => { this.handleMonth_Click(e, 6) }}>6개월</div>
                </div>
                <div className="select_date_box">
                    <div className="select_date_box_input">
                        <Big3DatePicker
                            className="form-control"
                            setDate={new Date(this.state.FromDate)}
                            DateChange={this.handleCalendarChange}
                            id="FromDate"
                        />
                        <div className="calendar_btn"></div>
                    </div>
                    <div className="select_date_box_input">
                        <Big3DatePicker
                            className="form-control"
                            setDate={new Date(this.state.ToDate)}
                            DateChange={this.handleCalendarChange}
                            id="ToDate"
                        />
                        <div className="calendar_btn"></div>
                    </div>
                    <button type="button" className="date_s_btn" onClick={this.handleSearch_Click}>조회</button>
                </div>
            </div>

        )
    }
    //거래내역
    DealHistoryrender()  {
        
        if(this.state.DealHistory.length===0){
            return false;
        }
        const DealHistoryModel = Big3Common.Util.groupBy(this.state.DealHistory, list => list.ord_dt);
        let DealHistory = [];
        for (const item of DealHistoryModel.entries()) {
            DealHistory.push({ "Date": item[0], "Childlist": item[1]});
        } 
        return(
            <>
                {
                    DealHistory.map(list=>
                        <div>
                            <div className="date" key={list.Date}>{list.Date}</div>
                            {
                                list.Childlist.map(subList=>
                                    <div className="alert_content_v3">
                                        <div className="alert_img">
                                             <ComPhoto className="alert_img_in" Photo={subList.photo} />
                                        </div>
                                        <div className="alert_txt">
                                            <div className="alert_title">{subList.org_nm}</div>
                                            <div className="product_name">주문 품목: {subList.goods_names}</div>
                                            <div className="product_name">주문 금액: {Big3Common.Util.Money(subList.goods_price_tot)}원</div>
                                            <div className="product_name"> 결제: {subList.pay_idx_nm}</div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            </>
        )
    }
    render() {
        const Searchrender=this.Searchrender();
        const DealHistoryrender=this.DealHistoryrender();
        return (
            <>
                <div className="container_box2 p_margin u_padding history_box2">
                    {Searchrender}
                    {DealHistoryrender}
                     <NoResult
                        Visible={this.state.DealHistory.length===0 ? true : false}
                        Top={"50%"}
                     />
                </div>
                
            </>
        );
    }
}
